<app-loader [enable]="loading$ | async">
  <app-cell-chart width="100%"
                  height="82px"
                  [data]="importedData$ | async"></app-cell-chart>
</app-loader>
